<template>
  <div>

    <!-- Styled -->
    <b-form-group
        :label="this.input-text"

    >
      <b-form-file
          v-model="file"
          placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
          drop-placeholder="Drop file here..."
      />

    </b-form-group>

    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="mr-1 upload-btn"
        @click="upload()"
        :variant="this.button-color"
    >
      {{this.button-text}}
    </b-button>


  </div>
</template>


<script>
import { BFormFile,BButton ,BFormGroup} from 'bootstrap-vue'
import Swal from "sweetalert2";
import axios from "@/libs/axios";
import {$themeConfig} from "@themeConfig";
import uploadService from "@/modules/services/uploadService";

export default {
  name:'upload',
  props:['title' , 'button-text' , 'input-text' , 'button-color'],
  components: {
    BFormFile,
    BButton,
    BFormGroup
  },
  data() {
    return {
      file: null,
      file2: null,
      currentFileAddress:null
    }
  },
  methods:{
  async  upload(){
      Swal.showLoading();
      this.currentFileAddress = await uploadService.upload(this.file)
  }
  }
}
</script>

<style scoped>
.upload-btn{
  margin: 15px 0;
}
</style>
